export default __webpack_public_path__ + "static/media/coins_stack.9cf9fba7.svg";